/* istanbul ignore file */

export default {
  "privacy-policy": "https://web.vodafone.com.eg/en/privacy-policy-of-vodafone-egypt_hid",
  "cookie-preferences": "cookie-preferences",
  "terms-and-conditions": "https://web.vodafone.com.eg/en/vodafone-red1",
  "help-and-support": "https://web.vodafone.com.eg/call-us",
};
